import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { AuthService } from '../auth.service';
import { Router } from '@angular/router';
import { MetadataService } from '../MetadataService';
import { AllJobsService } from '../AllJobsSevice';
import { Observable } from 'rxjs';
import { shareReplay, map } from 'rxjs';
import { environment } from '../../environments/environment';
import { KeycloakAuthService } from '../keycloak-auth.service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  searchJobByLocationKeywords: FormGroup;
  jobsCount: number;
  metadata$: Observable<any>;
  locations$: Observable<any>;
  epimelitiriou: string;

  constructor(
    private formBuilder: FormBuilder,
    public authService: AuthService,
    private router: Router,
    private metadataService: MetadataService,
    private allJobsService: AllJobsService,
    private keycloakAuth: KeycloakAuthService,
    private http: HttpClient
  ) { }

  ngOnInit() {
    this.epimelitiriou = environment.chamber2;

    this.metadata$ = this.metadataService.getMetaData().pipe(shareReplay(1));

    this.locations$ = this.metadata$.pipe(
      map(metadata =>
        [{ id: -1, text: 'Ολες οι Περιοχές' }].concat(
          metadata.locations.map(location => ({ id: location.id, text: location.name }))
        )
      )
    );

    this.allJobsService.getJobsCount().subscribe(number => {
      this.jobsCount = number;
    });

    this.searchJobByLocationKeywords = this.formBuilder.group({
      locationId: new FormControl(null),
      keyword: new FormControl(''),
    });

    const locationId = this.searchJobByLocationKeywords.get('locationId');
    locationId.valueChanges.subscribe(val => {
      if (val == -1) {
        locationId.setValue(null, { emitEvent: false });
      }
    });

    this.authService.authenticated.subscribe(() => {
      this.handlePostLogin();
    });
  }

  login() {
    this.keycloakAuth.login({
      redirectUri: window.location.origin + '/'
    });
  }

  register() {
    this.keycloakAuth.login({
      redirectUri: window.location.origin + '/',
      action: 'register'
    });
  }

  private handlePostLogin() {
    if (this.authService.isCompany()) {
      const companyData = {
        companyId: this.authService.getSessionUser().companyId,
        keycloakId: this.authService.getSessionUser().keycloakId,
      }
      this.authService.checkCompanyProfile(companyData).subscribe((data: any) => {
        if (data.isValid === false) {
          this.router.navigate(['employers/complete-profile']);
        }
      });
    } else if (this.authService.isCandidate()) {
      const candidateSession = this.authService.getSessionUser();
      const candidateKeycloakData = {
        keycloakId: candidateSession.keycloakId,
        firstName: candidateSession.firstName,
        lastName: candidateSession.lastName,
        email: candidateSession.email,
        afm: candidateSession.afm
      }
      this.authService.getCandidateProfile(candidateKeycloakData.keycloakId).subscribe((data: any) => {
        if (data.isValid === false) {
          this.router.navigate(['candidates/complete-profile']);
        }
      });
    } else if (this.authService.isAdminFunc()) {
      this.router.navigate(['administrator/cvHandling/', this.authService.getSessionUser().keycloakId]);
    }
  }

  getJobListByLocationKeywords() {
    if (this.searchJobByLocationKeywords.invalid) return;

    this.router.navigate(['/job-listing'], {
      queryParams: {
        locationId: this.searchJobByLocationKeywords.get('locationId').value,
        keywords: this.searchJobByLocationKeywords.get('keyword').value
      }
    });
  }
}